import * as React from 'react'

import { IntegrationStatusLabel } from 'components/IntegrationStatusLabel'

type AccordionTitleContentProps = {
  title: string
  isActive: boolean
}

export default function AccordionTitleContent({ title, isActive }: AccordionTitleContentProps) {
  return (
    <>
      {title}
      <span className="ml-4">
        <IntegrationStatusLabel active={isActive} />
      </span>
    </>
  )
}



// WEBPACK FOOTER //
// ./src/components/EmbeddingCyclrIntegration/AccordionTitleContent.tsx